import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function PolylineWithDirections(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 20 17">
        <path d="M2 9L18 9" stroke="#2A2A2A" stroke-width="2" stroke-linecap="round" />
        <circle cx="2.5" cy="9" r="2" fill="#2A2A2A" />
        <circle cx="17.5" cy="9" r="2" fill="#2A2A2A" />
        <circle
          cx="10.5"
          cy="8.5"
          r="4.09091"
          fill="white"
          stroke="#2A2A2A"
          strokeWidth="0.818182"
        />
        <path
          d="M9.90903 6.9957L11.5709 8.45624L10.1104 10.1182"
          stroke="#2A2A2A"
          strokeWidth="0.818182"
        />
      </svg>
    </IconContainer>
  )
}
